import { ReplaceMentionedUser } from "../orders/utils";

export const mapOptionsToUi = (options, valueKey, nameKey) =>
    options.map((item) => ({
        value: item["type"] === "branches" ? item["attributes"][valueKey] : item[valueKey],
        label: item["attributes"][nameKey],
    }));
export const mapTruckOptionsToUi = (options, valueKey, nameKey) =>
    options.map((item) => ({
        value: item[valueKey],
        label: item["attributes"][nameKey],
    }));
export const mapConstantsToUi = (options, valueKey, nameKey) =>
    options.map((item) => ({ value: item[valueKey], label: item[nameKey] }));
export const filterArrayByString = (array, string) =>
    array?.filter((o) =>
        Object.keys(o).some((k) => o[k].toLowerCase().includes(string.toLowerCase()))
    );

export const mapSectionsItemsToUi = (options, valueKey, nameKey) =>
    options.map((item) => ({
        value: item[valueKey],
        label: item["attributes"][nameKey],
    }));
function hasParty(partyToCheck, data) {
    return data.some((item) => item.attributes.party === partyToCheck);
}

export const mapProjectProfileToUi = (
    projectData,
    organizationData,
    attachments,
    standardsAndOperationalProcedures,
    projectPenaltiesAndDeductions,
    penaltiesAndDeductions
) => ({
    clientName: organizationData[0]["attributes"]?.name || "",
    requestedAt: projectData[0]["attributes"]?.requestedAt || "",
    projectType: projectData[0]["attributes"]?.projectType || "",
    name: projectData[0]["attributes"]?.name || "",
    isRfq: projectData[0]["attributes"]?.isRequestForQuotation,
    status: projectData[0]["attributes"]?.status || "",
    salesConditionsId: projectData[0]["attributes"]?.conditionsIds.sort((a, b) => a - b),
    projectFinancialLegal: {
        supplyPaymentCycleDays: projectData[0]["attributes"]?.supplyPaymentCycleDays || null,
        supplyReviewCycle: projectData[0]["attributes"]?.supplyReviewCycle || null,
        supplyAttachments:
            attachments?.length > 0
                ? attachments
                      ?.filter((item) => item["attributes"]?.documentType === "supply_contract")
                      .map((item, index) => ({ ...item.attributes, id: item.id }))
                : [],

        desiredMargin: projectData[0]["attributes"]?.desiredContributionMargin || null,
        ClientCollection: projectData[0]["attributes"]?.clientCollectionCycleDays || null,
        invoicing: projectData[0]["attributes"]?.invoicingCycle || null,
        legal: projectData[0]["attributes"]?.legalTerms || "",
        deductions: projectData[0]["attributes"]?.penaltiesAndDeductions || "",
        PODs: projectData[0]["attributes"]?.podsCollectionCycleDays || null,
        hasDeductions: projectData[0]["attributes"]?.hasDeductionsPenalties,
        illaDeductions: hasParty("illa", penaltiesAndDeductions),
        clientDeductions: hasParty("client", penaltiesAndDeductions),
        targetPriceAttachments:
            attachments?.length > 0
                ? attachments
                      ?.filter(
                          (item) => item["attributes"]?.documentType === "target_price_document"
                      )
                      .map((item, index) => ({ ...item.attributes, id: item.id }))
                : [],

        specialPenaltiesAndDeductions: projectData[0]["attributes"]?.specialPenaltiesAndDeductions,
        salesAttachments:
            attachments?.length > 0
                ? attachments
                      ?.filter((item) => item["attributes"]?.documentType === "sales_contract")
                      .map((item, index) => ({ ...item.attributes, id: item.id }))
                : [],
    },
    deductionsValues: mapProjectDeductionsToUi(projectPenaltiesAndDeductions),
    qaDetails: {
        requireDocumentsCollection: projectData[0]["attributes"]?.requireDocumentsCollection,
        requiresIllaOperatorsInClientPremises:
            projectData[0]["attributes"]?.requiresIllaOperatorsInClientPremises,
        operationsSiteVisitDetails:
            projectData[0]["attributes"]?.operationsSiteVisitDetails || null,
        attachments:
            attachments?.length > 0
                ? attachments
                      ?.filter((item) => item["attributes"]?.documentType === "operational")
                      .map((item) => ({ ...item.attributes, id: item.id }))
                : [],
        neededDocumentsType: [],
        standardsAndOperationalProcedures:
            standardsAndOperationalProcedures?.length > 0
                ? standardsAndOperationalProcedures.map((item) => item.id)
                : [],
        hasPodDocument: projectData[0]["attributes"]?.hasPodDocument,
        hasGrnDocument: projectData[0]["attributes"]?.hasGrnDocument,
        specialStandardsAndOperationalProcedures:
            projectData[0]["attributes"]?.specialStandardsAndOperationalProcedures,
    },
});

export const mapSalesConditionToUi = (
    salesCondition,
    truckType,
    pickupLocation,
    objections,
    suppliers
) => {
    if (salesCondition.length > 0 || truckType.length > 0 || pickupLocation.length > 0) {
        return {
            status: salesCondition[0]["attributes"]?.status,
            pickUpLocation: {
                label: pickupLocation?.[0]?.["attributes"]?.nameEn,
                value: salesCondition?.[0]?.["attributes"]?.pickupLocationId,
            },
            truckType: {
                label: truckType[0]["attributes"]?.alias,
                value: salesCondition[0]["attributes"]?.truckTypeId,
            },
            numberOfTrucks: salesCondition[0]["attributes"]?.numberOfTrucks,
            truckTypeCheckbox: !!(
                salesCondition[0]["attributes"]?.trucksSpecialDetails !== null &&
                salesCondition[0]["attributes"]?.trucksSpecialDetails !== ""
            ),
            hasPreferredModelYear: salesCondition[0]["attributes"]?.hasPreferredModelYear,
            requiredModelYearStartsFrom: {
                label: salesCondition[0]["attributes"]?.requiredModelYearStartsFrom,
                value: salesCondition[0]["attributes"]?.requiredModelYearStartsFrom,
            },
            kickoffDate: new Date(salesCondition[0]["attributes"]?.kickoffDate),
            endDate: new Date(salesCondition[0]["attributes"]?.endDate),
            salesChannels: salesCondition[0]["attributes"]?.salesChannels.map((item) => ({
                label: item.value,
                value: item.key,
            })),
            serviceAreas: salesCondition[0]["attributes"]?.serviceAreas.map((item) => ({
                label: item.value,
                value: item.key,
            })),
            pickUpTime: new Date(Number(salesCondition[0]["attributes"]?.pickupTime)),
            weeklyOffDays: salesCondition[0]["attributes"]?.offDays.map((item) => ({
                label: item.value,
                value: item.key,
            })),
            workingDaysPerMonth: salesCondition[0]["attributes"]?.workingDays,
            workingHoursPerDay: salesCondition[0]["attributes"]?.workingHoursPerDay,
            kiloMeters: salesCondition[0]["attributes"]?.distance,
            operationalDetailsCheckbox: !!(
                salesCondition[0]["attributes"]?.operationalSpecialDetails !== null &&
                salesCondition[0]["attributes"]?.operationalSpecialDetails !== ""
            ),
            operationalSpecialDetails: salesCondition[0]["attributes"]?.operationalSpecialDetails,
            numberOfHelpers: salesCondition[0]["attributes"]?.numberOfHelpers,
            extraOperationalRequirements: [],
            deliveryDelegate: salesCondition[0]["attributes"]?.deliveryDelegate,
            facilitiesCheckbox: !!(
                salesCondition[0]["attributes"]?.facilitatorsSpecialDetails !== null &&
                salesCondition[0]["attributes"]?.facilitatorsSpecialDetails !== ""
            ),
            facilitatorsSpecialDetails: salesCondition[0]["attributes"]?.facilitatorsSpecialDetails,
            truckPricePerMonth: salesCondition[0]["attributes"]?.truckPricePerMonth || "",
            extraDayPrice: salesCondition[0]["attributes"]?.extraDayPrice || "",
            extraHourPrice: salesCondition[0]["attributes"]?.extraHourPrice || "",
            extraUnitDistancePrice: salesCondition[0]["attributes"]?.extraUnitDistancePrice || "",
            overnightPrice: salesCondition[0]["attributes"]?.overnightPrice || "",
            truckDailyPrice: salesCondition[0]["attributes"]?.truckDailyPrice || "",
            pricePerHelper: salesCondition[0]["attributes"]?.pricePerHelper || "",
            pricePerDelegate: salesCondition[0]["attributes"]?.pricePerDelegate || "",
            // gasAndOilPerUnitDistance: salesCondition[0]["attributes"]?.gasAndOilPerUnitDistance,
            oilPricePerKilometer: salesCondition[0]["attributes"]?.oilPricePerKilometer,
            fuelPricePerKilometer: salesCondition[0]["attributes"]?.fuelPricePerKilometer,
            excludeGasAndOil: salesCondition[0]["attributes"]?.excludeGasAndOil,
            deactivationReason: salesCondition[0]["attributes"]?.deactivationReason,
            deactivationStatus: salesCondition[0]["attributes"]?.deactivationStatus,
            goodsTransfer: salesCondition[0]["attributes"]?.goodsTransfer,
            cashCollection: salesCondition[0]["attributes"]?.cashCollection,
            distribution: salesCondition[0]["attributes"]?.distribution,
            scales: salesCondition[0]["attributes"]?.scales,
            tolls: salesCondition[0]["attributes"]?.tolls,
            returnable: salesCondition[0]["attributes"]?.returnable,
            workingOvernight: salesCondition[0]["attributes"]?.workingOvernight,
            workingOnHolidays: salesCondition[0]["attributes"]?.workingOnHolidays,
            specialExtraOperationalRequirments:
                salesCondition[0]["attributes"]?.specialExtraOperationalRequirments,
            maximumNumberOfDropOff: salesCondition[0]["attributes"]?.maximumNumberOfDropOff,
            pricingDetails: {
                truckPricePerMonth:
                    salesCondition[0]["attributes"]?.supplierTruckPricePerMonth || "",
                extraDayPrice: salesCondition[0]["attributes"]?.supplierExtraDayPrice || "",
                extraHourPrice:
                    salesCondition[0]["attributes"]?.supplierExtraWorkingHourPrice || "",
                overnightPrice: salesCondition[0]["attributes"]?.supplierOvernightPrice || "",
                pricePerDelegate: salesCondition[0]["attributes"]?.supplierPricePerDelegate || "",
                pricePerHelper: salesCondition[0]["attributes"]?.supplierPricePerHelper || "",
                otherDetails: salesCondition[0]["attributes"]?.supplierOtherDetails || "",
                excludeGasAndOil: salesCondition[0]["attributes"]?.supplierExcludeGasAndOil || "",
                GazPricePerkiloMeter:
                    salesCondition[0]["attributes"]?.supplierGasAndOilPerUnitDistance || "",
                extraUnitDistancePrice:
                    salesCondition[0]["attributes"]?.supplierExtraUnitDistancePrice || "",
            },
            supplierConditions: {
                projectMonthlySuppliers: salesCondition[0][
                    "attributes"
                ]?.projectMonthlySuppliers?.map((supply) => ({
                    supplier: suppliers.filter(
                        (item) => Number(item?.id) === supply?.supplierId
                    )[0]["attributes"]?.name,
                    numberOfTrucks: supply?.numberOfTrucks,
                    assignedTrucks: supply?.assignedTrucks?.map((trucks) => ({
                        truck: trucks?.plateNumber,
                        driver: trucks?.driverName,
                    })),
                    kiloMeters: supply?.distance,
                    workingHoursPerDay: supply?.workingHoursPerDay,
                })),
                supplierCreatorId: salesCondition[0]["attributes"]?.supplierCreatorId,
                supplierCreatorType: null,
                supplierDeliveryDelegate: salesCondition[0]["attributes"]?.supplierDeliveryDelegate,
                supplierExcludeGasAndOil: salesCondition[0]["attributes"]?.supplierExcludeGasAndOil,
                supplierNumberOfHelpers: salesCondition[0]["attributes"]?.supplierNumberOfHelpers,
                supplierOtherDetails: salesCondition[0]["attributes"]?.supplierOtherDetails,
            },
            objectionsId:
                objections?.length > 0
                    ? objections?.reverse()?.map((item, index) => ({
                          text: `objection ${index + 1}`,
                          id: item.id,
                          label: item["attributes"].resolved ? "resolved" : "pending",
                      }))
                    : [],
        };
    }
    return null;
};
export const mapSupplierConditionToUi = (
    supplierCondition,
    supplier,
    truckType,
    branch,
    objections
) => {
    if (supplierCondition.length > 0 || supplier.length > 0) {
        return {
            status: supplierCondition[0]["attributes"]?.status,
            supplierCreatorId: supplierCondition[0]["attributes"]?.supplierCreatorId,
            fullFillmentDetails: {
                suppliers: supplierCondition[0]["attributes"]?.projectMonthlySuppliers.map(
                    (supplierItem) => ({
                        supplier: {
                            value: supplierItem?.supplierId,
                            label: supplier.filter(
                                (item) => Number(item?.id) === supplierItem?.supplierId
                            )[0]["attributes"]?.name,
                        },
                        trucksList: [],
                        numberOfTrucks: supplierItem?.numberOfTrucks,
                        workingHoursPerDay: supplierItem?.workingHoursPerDay,
                        kiloMeters: supplierItem?.distance,
                        assignedTrucks:
                            supplierItem?.assignedTrucks?.length > 0
                                ? supplierItem?.assignedTrucks?.map((trucks) => ({
                                      truck: {
                                          value: trucks?.truckId,
                                          isDeleted: trucks?.isDeleted,
                                          label: trucks?.plateNumber,
                                      },
                                      driver: {
                                          value: trucks?.driverId,
                                          label: trucks.driverName,
                                      },
                                  }))
                                : Array.from(
                                      {
                                          length: supplierItem?.numberOfTrucks,
                                      },
                                      () => ({
                                          value: "",
                                          label: "",
                                      })
                                  ),
                    })
                ),
                numberOfHelpers: supplierCondition[0]["attributes"]?.supplierNumberOfHelpers,
                deliveryDelegate: supplierCondition[0]["attributes"]?.supplierDeliveryDelegate,
            },
            truckPricePerMonth: supplierCondition[0]["attributes"]?.truckPricePerMonth,
            extraDayPrice: supplierCondition[0]["attributes"]?.extraDayPrice,
            extraHourPrice: supplierCondition[0]["attributes"]?.extraHourPrice,
            extraUnitDistancePrice: supplierCondition[0]["attributes"]?.extraUnitDistancePrice,
            overnightPrice: supplierCondition[0]["attributes"]?.overnightPrice,
            truckDailyPrice: supplierCondition[0]["attributes"]?.truckDailyPrice || "",
            excludeGasAndOil: supplierCondition[0]["attributes"]?.excludeGasAndOil,
            oilPricePerKilometer: supplierCondition[0]["attributes"]?.oilPricePerKilometer,
            fuelPricePerKilometer: supplierCondition[0]["attributes"]?.fuelPricePerKilometer,
            kiloMeters: supplierCondition[0]["attributes"]?.kiloMeters,
            pricePerHelper: supplierCondition[0]["attributes"]?.pricePerHelper,
            pricePerDelegate: supplierCondition[0]["attributes"]?.pricePerDelegate,
            pricingDetails: {
                truckPricePerMonth:
                    supplierCondition[0]["attributes"]?.supplierTruckPricePerMonth || "",
                extraDayPrice: supplierCondition[0]["attributes"]?.supplierExtraDayPrice || "",
                extraHourPrice:
                    supplierCondition[0]["attributes"]?.supplierExtraWorkingHourPrice || "",
                overnightPrice: supplierCondition[0]["attributes"]?.supplierOvernightPrice || "",
                pricePerDelegate:
                    supplierCondition[0]["attributes"]?.supplierPricePerDelegate || "",
                pricePerHelper: supplierCondition[0]["attributes"]?.supplierPricePerHelper || "",
                otherDetails: supplierCondition[0]["attributes"]?.supplierOtherDetails || "",
                excludeGasAndOil:
                    supplierCondition[0]["attributes"]?.supplierExcludeGasAndOil || "",
                GazPricePerkiloMeter:
                    supplierCondition[0]["attributes"]?.supplierGasAndOilPerUnitDistance || "",
                extraUnitDistancePrice:
                    supplierCondition[0]["attributes"]?.supplierExtraUnitDistancePrice || "",
                confirmSops: false,
            },
            salesConditions: {
                truckTypeName: truckType[0]["attributes"]?.alias,
                deliveryDelegate:
                    supplierCondition[0]["attributes"]?.salesConditions?.deliveryDelegate,
                numberOfHelpers: supplierCondition[0]["attributes"]?.numberOfHelpers,
                kiloMeters: supplierCondition[0]["attributes"]?.distance,
                excludeGasAndOil: supplierCondition[0]["attributes"]?.excludeGasAndOil,
                facilitatorsSpecialDetails:
                    supplierCondition[0]["attributes"]?.facilitatorsSpecialDetails,
                goodsTransfer: supplierCondition[0]["attributes"]?.goodsTransfer,
                cashCollection: supplierCondition[0]["attributes"]?.cashCollection,
                distribution: supplierCondition[0]["attributes"]?.distribution,
                scales: supplierCondition[0]["attributes"]?.scales,
                tolls: supplierCondition[0]["attributes"]?.tolls,
                returnable: supplierCondition[0]["attributes"]?.returnable,
                workingOvernight: supplierCondition[0]["attributes"]?.workingOvernight,
                workingOnHolidays: supplierCondition[0]["attributes"]?.workingOnHolidays,
                specialExtraOperationalRequirments:
                    supplierCondition[0]["attributes"]?.specialExtraOperationalRequirments,
                kickoffDate: supplierCondition[0]["attributes"]?.kickoffDate,
                endDate: supplierCondition[0]["attributes"]?.endDate,
                maximumNumberOfDropOff: supplierCondition[0]["attributes"]?.maximumNumberOfDropOff,
                numberOfTrucks: supplierCondition[0]["attributes"]?.numberOfTrucks,
                hasPreferredModelYear: supplierCondition[0]["attributes"]?.hasPreferredModelYear,
                requiredModelYearStartsFrom:
                    supplierCondition[0]["attributes"]?.requiredModelYearStartsFrom,
                offDays: supplierCondition[0]["attributes"]?.offDays,
                operationalSpecialDetails:
                    supplierCondition[0]["attributes"]?.operationalSpecialDetails,
                pickupTime: new Date(Number(supplierCondition[0]["attributes"]?.pickupTime)),
                salesChannels: supplierCondition[0]["attributes"]?.salesChannels,
                serviceAreas: supplierCondition[0]["attributes"]?.serviceAreas,
                trucksSpecialDetails: supplierCondition[0]["attributes"]?.trucksSpecialDetails,
                workingDays: supplierCondition[0]["attributes"]?.workingDays,
                workingHoursPerDay: supplierCondition[0]["attributes"]?.workingHoursPerDay,
                pickUpLocation: branch?.[0]?.["attributes"]?.nameAr,
            },
            ...(objections.length > 0 && {
                objectionsId: objections?.reverse()?.map((item, index) => ({
                    text: `objection ${index + 1}`,
                    id: item.id,
                    label: item["attributes"].resolved ? "resolved" : "pending",
                })),
            }),
        };
    }
    return null;
};

export const mapConditionToUi = (
    conditionData,
    truckType,
    pickupLocation,
    supplier,
    objections
) => ({
    status: conditionData[0]["attributes"]?.status,
    supplyData: {
        supplierOtherDetails: conditionData[0]["attributes"]?.supplierOtherDetails,
        supplierCreatorId: conditionData[0]["attributes"]?.supplierCreatorId,
        fullFillmentDetails: {
            suppliers: conditionData[0]["attributes"]?.projectMonthlySuppliers.map(
                (supplierItem) => ({
                    supplier: supplier.filter(
                        (item) => Number(item?.id) === supplierItem?.supplierId
                    )[0]["attributes"]?.name,
                    numberOfTrucks: supplierItem?.numberOfTrucks,
                    workingHoursPerDay: supplierItem?.workingHoursPerDay,
                    kiloMeters: supplierItem?.distance,
                    assignedTrucks: supplierItem?.assignedTrucks?.map((trucks) => ({
                        truck: trucks?.plateNumber,
                        driver: trucks?.driverName,
                    })),
                })
            ),
            numberOfHelpers: conditionData[0]["attributes"]?.supplierNumberOfHelpers,
            deliveryDelegate: conditionData[0]["attributes"]?.supplierDeliveryDelegate,
        },
        pricingDetails: {
            truckPricePerMonth: conditionData[0]["attributes"]?.supplierTruckPricePerMonth,
            extraDayPrice: conditionData[0]["attributes"]?.supplierExtraDayPrice,
            extraHourPrice: conditionData[0]["attributes"]?.supplierExtraWorkingHourPrice,
            overnightPrice: conditionData[0]["attributes"]?.supplierOvernightPrice,
            pricePerDelegate: conditionData[0]["attributes"]?.supplierPricePerDelegate,
            pricePerHelper: conditionData[0]["attributes"]?.supplierPricePerHelper,
            otherDetails: conditionData[0]["attributes"]?.supplierOtherDetails,
            excludeGasAndOil: conditionData[0]["attributes"]?.supplierExcludeGasAndOil,
            GazPricePerkiloMeter: conditionData[0]["attributes"]?.supplierGasAndOilPerUnitDistance,
            extraUnitDistancePrice: conditionData[0]["attributes"]?.supplierExtraUnitDistancePrice,
        },
    },
    salesData: {
        pickUpLocation: pickupLocation?.[0]?.["attributes"]?.nameEn,
        truckTypeName: truckType[0]["attributes"]?.alias,
        numberOfTrucks: conditionData[0]["attributes"]?.numberOfTrucks,
        trucksSpecialDetails: conditionData[0]["attributes"]?.trucksSpecialDetails,
        hasPreferredModelYear: conditionData[0]["attributes"]?.hasPreferredModelYear,
        requiredModelYearStartsFrom: conditionData[0]["attributes"]?.requiredModelYearStartsFrom,
        kickoffDate: conditionData[0]["attributes"]?.kickoffDate,
        endDate: conditionData[0]["attributes"]?.endDate,
        salesChannels: conditionData[0]["attributes"]?.salesChannels,
        serviceAreas: conditionData[0]["attributes"]?.serviceAreas,
        pickUpTime: new Date(Number(conditionData[0]["attributes"]?.pickupTime)),
        weeklyOffDays: conditionData[0]["attributes"]?.offDays,
        workingDaysPerMonth: conditionData[0]["attributes"]?.workingDays,
        workingHoursPerDay: conditionData[0]["attributes"]?.workingHoursPerDay,
        kiloMeters: conditionData[0]["attributes"]?.distance,
        operationalSpecialDetails: conditionData[0]["attributes"]?.operationalSpecialDetails,
        numberOfHelpers: conditionData[0]["attributes"]?.numberOfHelpers,
        goodsTransfer: conditionData[0]["attributes"]?.goodsTransfer,
        cashCollection: conditionData[0]["attributes"]?.cashCollection,
        distribution: conditionData[0]["attributes"]?.distribution,
        scales: conditionData[0]["attributes"]?.scales,
        tolls: conditionData[0]["attributes"]?.tolls,
        returnable: conditionData[0]["attributes"]?.returnable,
        workingOvernight: conditionData[0]["attributes"]?.workingOvernight,
        workingOnHolidays: conditionData[0]["attributes"]?.workingOnHolidays,
        specialExtraOperationalRequirments:
            conditionData[0]["attributes"]?.specialExtraOperationalRequirments,
        deliveryDelegate: conditionData[0]["attributes"]?.deliveryDelegate,
        maximumNumberOfDropOff: conditionData[0]["attributes"]?.maximumNumberOfDropOff,
        facilitatorsSpecialDetails: conditionData[0]["attributes"]?.facilitatorsSpecialDetails,
        truckPricePerMonth: conditionData[0]["attributes"]?.truckPricePerMonth,
        extraDayPrice: conditionData[0]["attributes"]?.extraDayPrice,
        extraHourPrice: conditionData[0]["attributes"]?.extraHourPrice,
        extraUnitDistancePrice: conditionData[0]["attributes"]?.extraUnitDistancePrice,
        overnightPrice: conditionData[0]["attributes"]?.overnightPrice,
        truckDailyPrice: conditionData[0]["attributes"]?.truckDailyPrice,
        pricePerHelper: conditionData[0]["attributes"]?.pricePerHelper,
        pricePerDelegate: conditionData[0]["attributes"]?.pricePerDelegate,
        // gasAndOilPerUnitDistance: conditionData[0]["attributes"]?.gasAndOilPerUnitDistance,
        oilPricePerKilometer: conditionData[0]["attributes"]?.oilPricePerKilometer,
        fuelPricePerKilometer: conditionData[0]["attributes"]?.fuelPricePerKilometer,
        vat: 35,
        deactivationReason: conditionData[0]["attributes"]?.deactivationReason,
        deactivationStatus: conditionData[0]["attributes"]?.deactivationStatus,
    },
    declinationDetails: {
        salesPricing: conditionData[0]["attributes"]?.declinationDetails?.salesPricing || null,
        supplierPricing: conditionData[0]["attributes"]?.declinationDetails?.supplierPricing || null,
        supplierFulfillment:
            conditionData[0]["attributes"]?.declinationDetails?.supplierFulfillment || null,
        clientRequirements:
            conditionData[0]["attributes"]?.declinationDetails?.clientRequirements || null,
    },
    ...(objections?.length > 0 && {
        objectionsId: objections?.reverse()?.map((item, index) => ({
            text: `objection ${index + 1}`,
            id: item.id,
            label: item["attributes"].resolved ? "resolved" : "pending",
        })),
    }),
});

export const mapObjectionsToUi = (
    creator,
    mentionedUsers,
    repliesUsers,
    item,
    section,
    comments,
    objection
) => ({
    creatorName: `${
        creator?.filter((item) => Number(item?.id) === objection[0]["attributes"]?.creatorId)[0][
            "attributes"
        ].firstName
    } ${
        creator?.filter((item) => Number(item?.id) === objection[0]["attributes"]?.creatorId)[0][
            "attributes"
        ].lastName
    }`,
    creatorEmail: creator?.filter(
        (item) => Number(item?.id) === objection[0]["attributes"]?.creatorId
    )[0]["attributes"].email,
    objectionStatus: objection[0]["attributes"]?.resolved ? "resolved" : "pending",
    createdAt: objection[0]["attributes"]?.createdAt,
    objectionSection: section[0]["attributes"]?.name,
    objectionItem: item[0]["attributes"]?.name,
    objectionComment: objection[0]["attributes"]?.description,
    objectionReplies: Object.keys(comments)
        .reverse()
        .map((key, i) => ({
            creatorName: `${
                repliesUsers?.filter(
                    (item) => Number(item?.id) === comments[key]["attributes"]?.adminUserId
                )[0]["attributes"].firstName
            } ${
                repliesUsers?.filter(
                    (item) => Number(item?.id) === comments[key]["attributes"]?.adminUserId
                )[0]["attributes"].lastName
            }`,

            creatorEmail: repliesUsers?.filter(
                (item) => Number(item?.id) === comments[key]["attributes"]?.adminUserId
            )[0]["attributes"].email,

            createdAt: comments[key]["attributes"]?.createdAt,
            replay: ReplaceMentionedUser(comments[key]["attributes"]?.content, mentionedUsers),
        })),
});

export const mapDeductionsToUi = (data) => {
    const deductions = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            deductions.push({ id: data[key].id, label: data[key].attributes.description });
        });
    }
    return deductions;
};

const mapProjectDeductionsToUi = (data) => {
    const mappedDeductions = {};
    Object.keys(data).forEach((key) => {
        const item = data[key];
        mappedDeductions[item.relationships?.penaltiesAndDeduction?.data?.id] = {
            comment: item.attributes.comment,
        };
    });

    return mappedDeductions;
};
